import React from "react";
import { useTranslation } from "react-i18next";
import { useMongoDBDataAdapterStats } from "../hooks/useMongoDBDataAdapter";
const MongoDBDataAdapterSummary = ({ dataAdapter }) => {
  var _a;
  const { t } = useTranslation("enterprise_lookup");
  const { data: statsData } = useMongoDBDataAdapterStats(dataAdapter.id);
  return /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dt", null, t("mongodb_summary.database_entries")), /* @__PURE__ */ React.createElement("dd", null, (_a = statsData == null ? void 0 : statsData.entriesCount) != null ? _a : 0), /* @__PURE__ */ React.createElement("dt", null, t("adapter_fields.cidr_lookup")), /* @__PURE__ */ React.createElement("dd", null, dataAdapter.config.cidr_lookup ? t("adapter_summary.yes") : t("adapter_summary.no")));
};
export default MongoDBDataAdapterSummary;
